module.exports = __webpack_public_path__ + "img/icon_health.46270a9.svg";